import BrandsService from "@/services/brands";
import CategoriesService from "@/services/categories";
import FileTypesService from "@/services/file-types";
import TagsService from "@/services/tags";
import YearsService from "@/services/years";

class FilesService {
    _DB_KEY = 'files';

    getFiles = (db, filters = {}) => {
        let collection = db.collection(this.dbKey);

        if (Object.keys(filters).length === 0 && filters.constructor === Object) {
            return collection.get();
        } else {
            if (filters.category) {
                collection = collection.where(`category.uuid`, "==", filters.category);
            }

            if (filters.fileType) {
                collection = collection.where(`fileType.uuid`, "==", filters.fileType);
            }

            if (filters.year) {
                collection = collection.where(`year.uuid`, "==", filters.year);
            }

            if (filters.brand) {
                collection = collection.where(`brand.uuid`, "==", filters.brand);
            }

            if (filters.tag) {
                collection = collection.where(`tag.uuid`, "==", filters.tag);
            }

            return collection.get();
        }
    }

    addFile = async (db, file) => {
        const document = db.collection(this.dbKey).doc();
        const body = {
            uuid: document.id,
            fileName: file.fileName,
            fileType: file.fileType,
            category: file.category,
            brand: file.brand,
            year: file.year,
            tag: file.tag,
            description: file.description ? file.description : '',
            thumbnail: file.thumbnail ? file.thumbnail : null,
            createdAt: new Date().toISOString(),
            url: file.url,
            ext: file.ext,
            downloads: 0
        };

        await BrandsService.incrementCounter(db, file.brand.uuid);
        await CategoriesService.incrementCounter(db, file.category.uuid);
        await FileTypesService.incrementCounter(db, file.fileType.uuid);
        await TagsService.incrementCounter(db, file.tag.uuid);
        await YearsService.incrementCounter(db, file.year.uuid);

        return document.set(body);
    }

    deleteFile = async (db, uuid) => {
        const document = db.collection(this.dbKey).doc(uuid);
        const data = await this.getFileByUUID(db, uuid);
        const file = data.data();

        await BrandsService.decrementCounter(db, file.brand.uuid);
        await CategoriesService.decrementCounter(db, file.category.uuid);
        await FileTypesService.decrementCounter(db, file.fileType.uuid);
        await TagsService.decrementCounter(db, file.tag.uuid);
        await YearsService.decrementCounter(db, file.year.uuid);

        return document.delete();
    }

    getFileByUUID = async (db, uuid) => {
        const document = db.collection(this.dbKey).doc(uuid);

        return document.get();
    }

    updateFile = async (db, uuid, payload) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);
        const document = await documentRef.get();
        const data = document.data();

        return documentRef.update({ ...data, ...payload });
    }

    updateDownloadsCounter = async (db, uuid) => {
        const documentRef = db.collection(this.dbKey).doc(uuid);
        const document = await documentRef.get();
        const data = document.data();

        const payload = {
            downloads: data.downloads + 1
        }

        return documentRef.update(payload);
    }

    get dbKey() {
        return this._DB_KEY
    }
}

export default new FilesService();



// WEBPACK FOOTER //
// ./src/services/files.js